import { OfficeHeader, Tabs } from "components";
import { useMatch, useSearch } from "react-location";

import Associates from "./associates";
import { FC } from "react";
import InsurerOffers from "./offers";
import { LocationGenerics } from "router/location";
import RemoveContainer from "./remove-associate";
import UpdateManagerContainer from "./update-associates";
import ViewInsurerAssociateContainer from "./view-associate";
import ViewInsurerOfferContainer from "./view";
import ViewInsurerOfferKEKContainer from "./view-kek";
import _ from "lodash";
import config from "config";
import { useInsurer } from "hooks/data/use-insurers";
import { useUrlState } from "utils";

type Props = {};
const tabs = [{ name: "Associates", href: "associates" }];

const InsurerPage: FC<Props> = () => {
  const { params } = useMatch<LocationGenerics>();
  const searchParams = useSearch<LocationGenerics>();
  const [modal, setModal] = useUrlState("modal");
  const [orderStatus] = useUrlState("orderStatus");

  const { insurer, loading: loadingInsurer } = useInsurer(
    params.insurer as string
  );

  return (
    <main className="flex-1 flex flex-col overflow-hidden bg-background-500">
      <OfficeHeader />
      <header>
        {/* Secondary navigation */}
        {/* Heading */}
        <div className="flex flex-col items-start justify-between gap-x-8 gap-y-4 bg-background-500 px-4 py-4 sm:flex-row sm:items-center sm:px-6 lg:px-8">
          <div>
            <div className="flex items-center gap-x-3">
              <div className="flex-none rounded-full bg-green-400/10 p-1 text-green-400">
                <div className="h-2 w-2 rounded-full bg-current" />
              </div>
              <h1 className="flex gap-x-3 text-base leading-7">
                <span className="font-semibold text-primary">
                  {loadingInsurer
                    ? "loading ..."
                    : insurer?.insurer_company_name}
                </span>
                <span className="text-gray-600">/</span>
                <span className="font-semibold text-primary">
                  {loadingInsurer ? "..." : insurer?.insurer_abbrv}
                </span>
              </h1>
            </div>
            <p className="mt-2 text-xs leading-6 text-tertiary">
              {insurer?.insurer_company_email} /{" "}
              {insurer?.insurer_company_website}
            </p>
          </div>
          <div className="order-first flex-none rounded-full bg-indigo-400/10 px-2 py-1 text-xs font-medium text-indigo-400 ring-1 ring-inset ring-indigo-400/30 sm:order-none">
            Active
          </div>
        </div>
      </header>
      <Tabs tabs={tabs} orderStatus={orderStatus} defaultTab="Offers" />
      {/* Activity list */}
      <>
        {orderStatus === "associates" && <Associates />}
        {!orderStatus && <InsurerOffers />}
      </>

      {searchParams.id && modal === "view-associate" && (
        <ViewInsurerAssociateContainer
          open={modal === "view-associate"}
          setOpen={(val: boolean) =>
            setModal(val ? "view-associate" : undefined)
          }
        />
      )}
      {searchParams.id && modal === "remove-associate" && (
        <RemoveContainer
          open={modal === "remove-associate"}
          setOpen={(val: boolean) =>
            setModal(val ? "remove-associate" : undefined)
          }
        />
      )}
      {searchParams.id && modal === "view" && config.appDomain === "KEK" && (
        <ViewInsurerOfferKEKContainer
          open={modal === "view"}
          setOpen={(val: boolean) => setModal(val ? "view" : undefined)}
        />
      )}
      {searchParams.id && modal === "view" && config.appDomain === "Visal" && (
        <ViewInsurerOfferContainer
          open={modal === "view"}
          setOpen={(val: boolean) => setModal(val ? "view" : undefined)}
        />
      )}
      {searchParams.id && modal === "update-associate" && (
        <UpdateManagerContainer
          open={modal === "update-associate"}
          setOpen={(val: boolean) =>
            setModal(val ? "update-associate" : undefined)
          }
        />
      )}
    </main>
  );
};

export default InsurerPage;
